export const DECIMAL = 'Decimal';
//# sourceMappingURL=DECIMAL.js.map